// Actividades adicionales de Gran Canaria verificadas en las páginas públicas
// facilitadas por OWA. Todas se confirman inicialmente por WhatsApp hasta que
// exista disponibilidad en tiempo real y contrato operativo con el proveedor.

const images = {
  buggy: '',
  dolphin: 'https://images.unsplash.com/photo-1518399681705-1c1a55e5e883?auto=format&fit=crop&w=1200&q=80',
  dive: '',
  diveWide: '',
  yacht: 'https://images.unsplash.com/photo-1571328532572-cb7899a8be7e?auto=format&fit=crop&w=1200&q=80',
  yachtWide: 'https://images.unsplash.com/photo-1526621480041-c4e2027dfe69?auto=format&fit=crop&w=1200&q=80',
  sunset: 'https://images.unsplash.com/photo-1499403474843-04e72c14df8a?auto=format&fit=crop&w=1200&q=80',
  catamaran: 'https://images.unsplash.com/photo-1564555449603-b0eefe1b9094?auto=format&fit=crop&w=1200&q=80',
  jetSki: 'https://images.unsplash.com/photo-1564633351631-e85bd59a91af?auto=format&fit=crop&w=1200&q=80',
  parasailing: 'https://images.unsplash.com/photo-1502680390469-be75c86b636f?auto=format&fit=crop&w=1200&q=80',
  paddle: 'https://images.unsplash.com/photo-1530789253388-582c481c54b0?auto=format&fit=crop&w=1200&q=80',
  boatParty: 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?auto=format&fit=crop&w=1200&q=80',
};

// --- 2026-08-24 update: real local photos + refreshed, provider-neutral copy
// for the buggy-tour and watersports-rental activities. Centralized by
// id so manualActivity() applies them without editing every entry. ---
const M = (folder, ...files) => files.map((f) => `/media/${folder}/${f}`);

const manualGalleries = {
  'gc-buggy-ayagaures': M('gc-buggy', 'buggy-01.jpg', 'buggy-02.jpg', 'buggy-03.jpg', 'buggy-04.jpg', 'buggy-05.jpg', 'buggy-06.jpg'),
  'gc-buggy-family': M('gc-buggy', 'buggy-02.jpg', 'buggy-03.jpg', 'buggy-04.jpg', 'buggy-05.jpg', 'buggy-06.jpg', 'buggy-01.jpg'),
  // Watersports: heroes use only the high-res photos; the tiny 275px "-01"
  // thumbnails are dropped so covers never look pixelated.
  'gc-anfi-jetski-alquiler': M('gc-watersports', 'jet-ski-family.jpg', 'jet-ski-02.jpg', 'jet-ski-03.jpg'),
  'gc-anfi-jetski-safari': M('gc-watersports', 'jet-ski-safari-02.jpg', 'jet-ski-safari-01.jpg'),
  'gc-anfi-parasailing': M('gc-watersports', 'parasailing-02.jpg', 'parasailing-03.jpg'),
  'gc-anfi-flyboard': M('gc-watersports', 'flyboard-02.jpg', 'flyboard-03.jpg'),
  'gc-anfi-wakeboard': M('gc-watersports', 'wakeboard-02.jpg', 'wakeboard-03.jpg'),
  'gc-anfi-esqui-acuatico': M('gc-watersports', 'water-ski-01.jpg', 'water-ski-02.jpg'),
  'gc-anfi-banana-boat': M('gc-watersports', 'banana-02.jpg', 'banana-03.jpg'),
  'gc-anfi-crazy-sofa': M('gc-watersports', 'crazy-sofa-02.jpg'),
  'gc-anfi-water-bull': M('gc-watersports', 'water-bull-01.jpg', 'water-bull-02.jpg', 'water-bull-03.jpg'),
  // stingray-01 shows the provider logo on the sail — use the clean aerial shots.
  'gc-mogan-catamaran-stingray': M('gc-watersports', 'stingray-02.jpg', 'stingray-03.jpg', 'stingray-04.jpg'),
  'gc-catamaran-bluefin-compartido': M('gc-watersports', 'bluefin-01.jpg', 'bluefin-02.jpg', 'bluefin-03.jpg', 'bluefin-04.jpg'),
  'gc-catamaran-bluefin-privado': M('gc-watersports', 'bluefin-03.jpg', 'bluefin-04.jpg', 'bluefin-02.jpg'),
  'gc-anfi-coche-patin': M('gc-watersports', 'pedal-boat-02.jpg', 'pedal-boat-03.jpg'),
  'gc-anfi-kayak-alquiler': M('gc-watersports', 'kayak-02.jpg'),
  'gc-anfi-paddle-surf-alquiler': M('gc-watersports', 'paddle-surf-02.jpg'),
  'gc-anfi-speed-boat': M('gc-watersports', 'speed-boat-01.jpg'),
  'gc-anfi-sun-pack': M('gc-watersports', 'sun-pack-01.jpg', 'sun-pack-03.jpg'),
  'gc-anfi-fun-pack': M('gc-watersports', 'fun-pack-01.jpg', 'fun-pack-02.jpg', 'fun-pack-03.jpg'),
  'gc-anfi-adventure-pack': M('gc-watersports', 'speed-boat-01.jpg', 'parasailing-02.jpg', 'adventure-pack-01.jpg'),
  'gc-yate-crucero-snorkel': M('gc-nirvana', 'yacht-exterior.jpg', 'guests-onboard.jpg', 'celebration.jpg', 'dolphin-cruise.jpg'),
  'gc-yate-sunset-tour': M('gc-nirvana', 'yacht-exterior.jpg', 'sunset-experience.jpg', 'sunset-couple.jpg', 'couple-onboard.jpg'),
  'gc-yate-delfines-chill': M('gc-nirvana', 'dolphin-cruise.jpg', 'guests-onboard.jpg', 'yacht-exterior.jpg'),
  'gc-yate-gui-gui': M('gc-nirvana', 'yacht-exterior.jpg', 'guests-onboard.jpg', 'celebration.jpg', 'branded-seating.jpg'),
  'gc-yate-privado-exclusivo': M('gc-nirvana', 'dolphin-cruise.jpg', 'couple-onboard.jpg', 'cabin.jpg', 'branded-seating.jpg', 'yacht-exterior.jpg'),
  'gc-yate-all-inclusive': M('gc-nirvana', 'yacht-exterior.jpg', 'guests-onboard.jpg', 'celebration.jpg'),
};

const manualContent = {
  'gc-buggy-ayagaures': {
    title: 'Buggy Tour por Ayagaures',
    shortDescription: 'Ruta guiada en buggy por Ayagaures con miradores, tramos off-road y opción de cambiar de conductor.',
    description: 'Tour guiado de 2 horas y 15 minutos con salida desde El Tablero. La ruta recorre el sur de Gran Canaria, pasa por el mirador de Pedro González y Ayagaures e incluye tramos fuera de carretera. Durante la experiencia es posible cambiar de conductor.',
  },
  'gc-buggy-family': {
    title: 'Family & Friends Buggy Tour',
    shortDescription: 'Tour familiar para tres participantes por Ayagaures, con miradores y tramos off-road.',
    description: 'Experiencia de 2 horas y 15 minutos para familias o grupos de amigos, con configuración para tres participantes. Sale desde El Tablero y recorre el mirador de Pedro González, Ayagaures y tramos off-road por el sur de Gran Canaria.',
  },
  'gc-anfi-jetski-alquiler': {
    title: 'Moto Acuática en Anfi del Mar',
    shortDescription: 'Moto acuática individual o doble, sin licencia, con opciones de 20 y 30 minutos.',
    description: 'Conduce una moto acuática frente a Anfi del Mar durante 20 o 30 minutos. No necesitas licencia ni experiencia previa: te explicamos el manejo y las normas de seguridad antes de comenzar.',
  },
  'gc-anfi-jetski-safari': {
    title: 'Jet Ski Safari',
    shortDescription: 'Safari guiado en moto acuática por la costa, con recorridos de una o dos horas.',
    description: 'Safari guiado en moto acuática por la costa de Gran Canaria. Elige una salida aproximada de una hora en moto individual o doble, o amplía el recorrido a dos horas para una o dos personas.',
  },
  'gc-anfi-parasailing': {
    title: 'Paracaídas Acuático — Parasailing',
    shortDescription: 'Vuelo en parasailing desde Puerto de Mogán para una, dos o tres personas.',
    description: 'Disfruta de las vistas de la costa desde un paracaídas acuático remolcado por embarcación. La experiencia sale desde Puerto de Mogán y admite vuelos para una, dos o tres personas, además de acompañantes a bordo.',
  },
  'gc-anfi-flyboard': {
    title: 'Flyboard',
    shortDescription: 'Sesión supervisada de flyboard en Anfi del Mar, disponible en 20 o 30 minutos.',
    description: 'Sesión de flyboard en Anfi del Mar para aprender a elevarte y desplazarte sobre el agua con la ayuda de nuestro equipo. Disponible en sesiones de 20 o 30 minutos.',
  },
  'gc-anfi-wakeboard': {
    title: 'Wakeboard',
    shortDescription: 'Wakeboard de 15 minutos o sesión de 30 minutos con profesor.',
    description: 'Sesión de wakeboard de 15 minutos o modalidad de 30 minutos con profesor para trabajar la técnica con acompañamiento.',
  },
  'gc-anfi-esqui-acuatico': {
    title: 'Esquí Acuático',
    shortDescription: 'Esquí acuático de 15 minutos o sesión de 30 minutos con profesor.',
    description: 'Sesión de esquí acuático de 15 minutos o modalidad de 30 minutos con profesor para iniciarte o mejorar la técnica.',
  },
  'gc-anfi-banana-boat': {
    title: 'Banana Boat',
    shortDescription: 'Banana boat de 10 minutos para grupos de al menos tres participantes.',
    description: 'Actividad en grupo sobre una banana hinchable arrastrada por lancha durante unos 10 minutos. La velocidad y el recorrido se adaptan a las condiciones y al grupo.',
  },
  'gc-anfi-crazy-sofa': {
    title: 'Crazy Sofa',
    shortDescription: 'Sofá acuático arrastrado por lancha durante 10 minutos, individual o en pareja.',
    description: 'Actividad de velocidad sobre un sofá hinchable arrastrado por lancha. Puede realizarse de forma individual o en pareja, con chaleco y supervisión del equipo.',
  },
  'gc-anfi-water-bull': {
    title: 'Water Bull',
    shortDescription: 'Water Bull de 10 minutos con velocidad adaptada a la edad del grupo.',
    description: 'Actividad de arrastre sobre un hinchable Water Bull. Adaptamos la velocidad a la edad y al nivel del grupo para una experiencia divertida y controlada.',
  },
  'gc-mogan-catamaran-stingray': {
    title: 'Catamarán Stingray',
    shortDescription: 'Catamarán en grupo reducido desde Puerto de Mogán con almuerzo, bebidas, snorkel y paddle surf.',
    description: 'Navega desde Puerto de Mogán en un catamarán de nueva construcción. La ruta explora playas vírgenes, acantilados y cuevas marinas en un grupo reducido, con tiempo para nadar, hacer snorkel y practicar paddle surf. Incluye almuerzo y bebidas.',
  },
  'gc-catamaran-bluefin-compartido': {
    title: 'Catamarán Bluefin — Salida Compartida',
    shortDescription: 'Salida compartida en el catamarán Lagoon 42 desde Puerto de Mogán para un máximo de 12 personas.',
    description: 'Salida compartida desde Puerto de Mogán en el catamarán Lagoon 42 Millennium. Cuenta con amplias zonas exteriores, interiores luminosos y navegación estable, siempre con patrón profesional y un máximo de 12 personas.',
  },
  'gc-catamaran-bluefin-privado': {
    title: 'Catamarán Bluefin — Salida Privada',
    shortDescription: 'Catamarán Lagoon 42 privado para hasta 12 personas, con salidas de 2 a 8 horas.',
    description: 'Alquiler privado del catamarán Lagoon 42 Millennium desde Puerto de Mogán. La salida se adapta a grupos de hasta 12 personas y puede contratarse en duraciones de 2, 3, 4, 6 u 8 horas, siempre con patrón profesional.',
  },
  'gc-anfi-coche-patin': {
    title: 'Coche Patín',
    shortDescription: 'Coche patín familiar durante una hora para hasta cuatro personas.',
    description: 'Alquiler de coche patín durante una hora para navegar frente a Anfi del Mar. Una opción tranquila y apta para familias, con capacidad para hasta cuatro personas.',
  },
  'gc-anfi-kayak-alquiler': {
    title: 'Alquiler de Kayak',
    shortDescription: 'Kayak individual o doble durante 60 minutos en Anfi del Mar.',
    description: 'Alquiler de kayak individual o doble durante 60 minutos en Anfi del Mar. Antes de salir te entregamos el chaleco y explicamos las pautas básicas de seguridad.',
  },
  'gc-anfi-paddle-surf-alquiler': {
    title: 'Alquiler de Paddle Surf',
    shortDescription: 'Alquiler de paddle surf en Anfi del Mar durante una o dos horas.',
    description: 'Alquila una tabla de paddle surf en Anfi del Mar durante una o dos horas para remar a tu ritmo frente a la costa.',
  },
  'gc-anfi-speed-boat': {
    title: 'Speed Boat — Crazy Jet',
    shortDescription: 'Paseo en lancha rápida con opciones de 20 minutos o 1 hora y 15 minutos.',
    description: 'Paseo en lancha rápida con una opción corta de 20 minutos o un recorrido ampliado de 1 hora y 15 minutos por la costa.',
  },
  'gc-anfi-sun-pack': {
    title: 'Sun Pack',
    shortDescription: 'Moto acuática, parasailing, banana o Crazy Sofa, más hamaca y sombrilla.',
    description: 'Pack acuático que combina 20 minutos de moto acuática, un vuelo en parasailing de entre 8 y 10 minutos y 10 minutos de banana o Crazy Sofa. Incluye hamaca y sombrilla para relajarse después.',
  },
  'gc-anfi-fun-pack': {
    title: 'Fun Pack',
    shortDescription: 'Moto acuática durante 20 minutos y vuelo en parasailing de 8 a 10 minutos.',
    description: 'Pack que combina 20 minutos de moto acuática y un vuelo en parasailing de entre 8 y 10 minutos. Coordinamos el horario de cada actividad según disponibilidad.',
  },
  'gc-anfi-adventure-pack': {
    title: 'Adventure Pack',
    shortDescription: 'Speed Boat, parasailing y Crazy Sofa en un único pack de aventura.',
    description: 'Pack de aventura con 20 minutos de Speed Boat, un vuelo en parasailing de entre 8 y 10 minutos y una sesión de Crazy Sofa de entre 10 y 12 minutos.',
  },
  'gc-yate-crucero-snorkel': {
    title: 'Crucero & Snorkel — Yate Privado',
    shortDescription: 'Yate privado de 4 horas con snorkel, paddle surf, donut tube, bebidas y snacks.',
    description: 'Excursión privada de cuatro horas a bordo de nuestro yate privado para explorar la costa de Gran Canaria, relajarse en las zonas de sol y sombra y disfrutar de una parada de baño con actividades acuáticas.',
  },
  'gc-yate-sunset-tour': {
    title: 'Sunset Tour — Yate Privado',
    shortDescription: 'Puesta de sol privada de 3 horas con bebidas, snacks y parada de baño opcional.',
    description: 'Tour privado de tres horas para contemplar cómo el sol se pone sobre el Atlántico. Pensado para parejas, familias y grupos pequeños, con espacio para relajarse, música y una parada de baño opcional si las condiciones lo permiten.',
  },
  'gc-yate-delfines-chill': {
    title: 'Delfines & Chill — Crucero Privado',
    shortDescription: 'Crucero privado de 5 horas para observar de forma ocasional delfines, aves y vida marina.',
    description: 'Crucero privado de cinco horas centrado en la observación ocasional y responsable de delfines, aves marinas y otra fauna del Atlántico. El recorrido permite relajarse a bordo mientras la tripulación busca señales de vida marina.',
  },
  'gc-yate-gui-gui': {
    title: 'Güi Güi Hidden Gem — Yate Privado',
    shortDescription: 'Excursión privada de 6 horas a Güi Güi con paella, bebidas premium y actividades acuáticas.',
    description: 'Navegación privada de seis horas hacia la playa de Güi Güi, uno de los enclaves más aislados de Gran Canaria y accesible principalmente por mar o mediante una larga caminata. Se recomienda la salida de mañana.',
  },
  'gc-yate-privado-exclusivo': {
    title: 'Yate Privado — Tour Exclusivo',
    shortDescription: 'Tour privado de 3 horas para hasta 8 personas con actividades acuáticas, bebidas y snacks.',
    description: 'Tour privado de tres horas para disfrutar del mar con total tranquilidad. El yate ofrece zonas para tomar el sol o descansar a la sombra, música, bebidas, snacks y material para completar la experiencia con actividades acuáticas.',
  },
  'gc-yate-all-inclusive': {
    title: 'All Inclusive Water Adventure — Yate Privado',
    shortDescription: 'Yate privado con una actividad a elegir: jet ski, Banana Boat o Crazy UFO.',
    description: 'Experiencia privada de tres horas que combina navegación, música, bebidas y una actividad de adrenalina incluida. El grupo puede elegir entre moto acuática para dos personas, Banana Boat o Crazy UFO.',
  },
};

const buggyPartnerInfo = {
  id: 'gc-buggy-partner',
  name: 'Socio local de aventuras',
};

const marinePartnerInfo = {
  id: 'gc-marine-partner',
  name: 'Socio local de avistamiento marino',
};

const divePartnerInfo = {
  id: 'gc-dive-partner',
  name: 'Centro de buceo local',
};

const yachtPartnerInfo = {
  id: 'gc-yacht-partner',
  name: 'Socio de yates privados',
};

const watersportsPartnerInfo = {
  id: 'gc-watersports-partner',
  name: 'Socio de deportes acuáticos',
};

const diveCancellation = {
  verifiedOn: '2026-08-11',
  noticeHours: 24,
  short: 'No se admiten cancelaciones con menos de 24 horas.',
  details: 'El proveedor indica que el cliente no puede cancelar con menos de 24 horas de antelación. La actividad puede cancelarse por motivos organizativos o de seguridad.',
  sourceUrl: '',
};

const dolphinCancellation = {
  verifiedOn: '2026-08-11',
  noticeHours: null,
  short: 'Reembolso íntegro si el operador cancela por el estado del mar.',
  details: 'Si las condiciones del mar no permiten navegar, el operador cancela la salida y devuelve el 100% de lo pagado. Las cancelaciones solicitadas por el cliente deben confirmarse antes de reservar.',
  sourceUrl: '',
};

const partnerVerifiedCancellation = {
  verifiedOn: '2026-08-11',
  noticeHours: 24,
  short: 'Cancelación gratuita hasta 24 horas antes.',
  details: 'La actividad enlazada publica cancelación gratuita hasta 24 horas antes del comienzo.',
  sourceUrl: '',
};

function unpublishedCancellation(providerName, sourceUrl) {
  return {
    verifiedOn: '2026-08-11',
    noticeHours: null,
    short: 'Condiciones de cancelación a confirmar antes de reservar.',
    details: 'En OWA confirmaremos las condiciones de cancelación aplicables a esta actividad por WhatsApp antes de realizar ningún cobro.',
    sourceUrl,
  };
}

function normalizeTickets(ticketTypes, price, priceUnit) {
  const source = ticketTypes?.length
    ? ticketTypes
    : [{ id: 'standard', label: priceUnit === 'persona' ? 'Personas' : 'Reserva', price }];

  return source.map((ticket, index) => ({
    min: 0,
    max: 12,
    default: index === 0 ? 1 : 0,
    ...ticket,
  }));
}

function manualActivity({
  id,
  title,
  provider,
  sourceUrl,
  priceSourceUrl = sourceUrl,
  location,
  category = 'nauticas',
  price,
  priceUnit = 'persona',
  duration,
  image,
  description,
  shortDescription = description,
  included = ['Gestión de disponibilidad con el operador local', 'Información previa a la actividad'],
  notIncluded = ['Servicios opcionales no indicados expresamente'],
  meetingPoint,
  pickup = 'Consultar disponibilidad de recogida con OWA.',
  groupSize = 'Grupo a confirmar',
  insurance = 'Según condiciones de la actividad',
  languages = 'ES / EN',
  restrictions = ['La actividad está sujeta a disponibilidad y condiciones meteorológicas.'],
  cancellationPolicy,
  ticketTypes,
  timeSlots = ['Horario a confirmar'],
  featured = false,
  bookingEnabled = false,
}) {
  // Apply the 2026-08-24 update: real local photos + refreshed neutral copy.
  const localGallery = manualGalleries[id];
  const content = manualContent[id] || {};
  return {
    id,
    title: content.title || title,
    location,
    destination: 'gran-canaria',
    category,
    price,
    originalPrice: null,
    duration,
    rating: null,
    reviews: 0,
    featured,
    image: localGallery ? localGallery[0] : image,
    gallery: localGallery || [image],
    shortDescription: content.shortDescription || shortDescription,
    description: content.description || description,
    included,
    notIncluded,
    meetingPoint,
    pickup,
    groupSize,
    insurance,
    languages,
    restrictions,
    provider: {
      ...provider,
      activityUrl: sourceUrl,
    },
    cancellationPolicy,
    ticketTypes: normalizeTickets(ticketTypes, price, priceUnit),
    timeSlots,
    priceUnit,
    paymentCurrency: 'EUR',
    bookingEnabled,
    priceVerifiedOn: '2026-08-11',
    priceSourceUrl,
  };
}

// The Infinity yacht activities (shared + private) now live in activityCatalog.js
// with real photos and full copy. Kept empty here to avoid duplicate ids.
const yachtTourActivities = [];

const buggyTourActivities = [
  manualActivity({
    id: 'gc-buggy-ayagaures',
    title: 'Buggy Pirates Tour',
    provider: buggyPartnerInfo,
    sourceUrl: '',
    priceSourceUrl: '',
    price: 120,
    priceUnit: 'buggy',
    duration: '2 h 15 min',
    image: images.buggy,
    category: 'aventura',
    location: 'El Tablero, Gran Canaria',
    meetingPoint: 'Base de buggies, El Tablero',
    pickup: 'Traslados incluidos desde zonas turísticas seleccionadas.',
    groupSize: 'Consultar ocupación por buggy',
    cancellationPolicy: unpublishedCancellation('Socio local de aventuras', ''),
    description: 'Ruta guiada en buggy por el sur de Gran Canaria con salida desde El Tablero y traslados desde zonas turísticas seleccionadas.',
    included: ['Buggy y guía de ruta', 'Traslados desde zonas seleccionadas', 'Información de seguridad'],
    notIncluded: ['Servicios no indicados en la reserva del operador'],
    ticketTypes: [{ id: 'buggy', label: 'Buggy', price: 120, max: 6, default: 1 }],
    featured: true,
  }),
  manualActivity({
    id: 'gc-buggy-family',
    title: 'Family & Friends Buggy Tour',
    provider: buggyPartnerInfo,
    sourceUrl: '',
    priceSourceUrl: '',
    price: 270,
    priceUnit: 'grupo',
    duration: '2 h 15 min',
    image: images.buggy,
    category: 'aventura',
    location: 'El Tablero, Gran Canaria',
    meetingPoint: 'Base de buggies, El Tablero',
    pickup: 'Traslados incluidos desde zonas turísticas seleccionadas.',
    groupSize: 'Configuración familiar para 3 participantes',
    cancellationPolicy: unpublishedCancellation('Socio local de aventuras', ''),
    description: 'Formato familiar y para grupos de amigos del tour en buggy por el sur de Gran Canaria.',
    ticketTypes: [{ id: 'family_group', label: 'Grupo de 3 participantes', price: 270, max: 1, default: 1 }],
  }),
];

const wildlifeActivities = [
  manualActivity({
    id: 'gc-delfines-ballenas-safari',
    title: 'Dolphin Safari — Delfines y Ballenas',
    provider: marinePartnerInfo,
    sourceUrl: '',
    price: 40,
    priceUnit: 'persona',
    duration: '3 horas',
    image: images.dolphin,
    category: 'naturaleza',
    location: 'Puerto Rico, Gran Canaria',
    meetingPoint: 'Puerto Base, Puerto Rico',
    pickup: 'Recogida incluida de Mogán a Playa del Cura y de Bahía Feliz a Arguineguín, solicitándola al reservar.',
    groupSize: 'Excursión compartida',
    insurance: 'Según condiciones del operador marítimo',
    cancellationPolicy: dolphinCancellation,
    description: 'Navegación por la costa suroeste de Gran Canaria en busca de delfines y ballenas con guías profesionales.',
    included: ['Excursión marítima con guía', 'Servicio de recogida en las zonas publicadas'],
    notIncluded: ['Servicios no indicados expresamente por el proveedor'],
    ticketTypes: [
      { id: 'adult', label: 'Adultos', price: 40, max: 20, default: 2 },
      { id: 'child', label: 'Menores (3-12)', price: 20, max: 20, default: 0 },
      { id: 'infant', label: 'Bebés (0-2)', price: 0, max: 5, default: 0 },
    ],
    timeSlots: ['10:30'],
    featured: true,
  }),
];

const diveActivities = [
  manualActivity({
    id: 'gc-snorkel-mogan',
    title: 'Snorkel Guiado desde Puerto de Mogán',
    provider: divePartnerInfo,
    sourceUrl: '',
    price: 69,
    duration: 'Duración a confirmar',
    image: images.dive,
    category: 'buceo',
    location: 'Puerto de Mogán, Gran Canaria',
    meetingPoint: 'Puerto de Mogán',
    groupSize: 'Grupo reducido',
    cancellationPolicy: diveCancellation,
    description: 'Experiencia de snorkel guiada para principiantes en una bahía protegida, desde barco o costa según el estado del mar.',
    included: ['Guía profesional', 'Máscara full face', 'Selección del mejor punto según el mar'],
    restrictions: ['Edad mínima: 6 años.', 'No apto para personas con problemas de movilidad o en silla de ruedas.'],
  }),
  manualActivity({
    id: 'gc-buceo-certificados',
    title: 'Buceo para Buceadores Certificados',
    provider: divePartnerInfo,
    sourceUrl: '',
    price: 116,
    duration: 'Según inmersiones',
    image: images.diveWide,
    category: 'buceo',
    location: 'Sur de Gran Canaria',
    meetingPoint: 'Playa del Inglés, Gran Canaria',
    groupSize: 'Grupos reducidos',
    cancellationPolicy: diveCancellation,
    description: 'Inmersiones para buceadores certificados en distintos puntos del sur, este, oeste y noroeste de Gran Canaria.',
    included: ['Guía profesional de buceo', 'Planificación según nivel y condiciones'],
    notIncluded: ['Alquiler de equipo cuando no esté incluido en la opción reservada'],
    restrictions: ['Es obligatorio disponer de certificación de buceo válida.'],
  }),
  manualActivity({
    id: 'gc-buceo-amadores',
    title: 'Bautizo de Buceo en Playa de Amadores',
    provider: divePartnerInfo,
    sourceUrl: '',
    price: 85,
    duration: 'Duración a confirmar',
    image: images.dive,
    category: 'buceo',
    location: 'Playa de Amadores, Gran Canaria',
    meetingPoint: 'Playa de Amadores',
    pickup: 'Recogida en hotel según zona y disponibilidad.',
    groupSize: 'Máx. 3 pers. por instructor',
    cancellationPolicy: diveCancellation,
    description: 'Primera experiencia de buceo en una bahía protegida, con briefing, equipo personal y profundidad máxima de 6 metros.',
    included: ['Instructor de buceo', 'Equipo personal', 'Briefing de seguridad', 'Recogida según zona'],
    restrictions: ['Actividad sujeta a cuestionario médico y condiciones del mar.'],
  }),
  manualActivity({
    id: 'gc-curso-open-water',
    title: 'Curso Open Water Diver SSI / PADI',
    provider: divePartnerInfo,
    sourceUrl: '',
    price: 450,
    duration: '2 días',
    image: images.diveWide,
    category: 'buceo',
    location: 'Gran Canaria',
    meetingPoint: 'Playa del Inglés, Gran Canaria',
    groupSize: 'Curso en grupo reducido',
    cancellationPolicy: diveCancellation,
    description: 'Curso de certificación internacional con teoría, aguas confinadas e inmersiones en mar abierto.',
    included: ['Formación teórica y práctica', 'Inmersiones en mar abierto', 'Máscara de buceo de regalo'],
    notIncluded: ['Extras y tasas de certificación que el proveedor no detalla en el precio base'],
    restrictions: ['Edad mínima: 10 años.', 'Sujeto a requisitos médicos de buceo.'],
  }),
  manualActivity({
    id: 'gc-velero-privado-4-5h',
    title: 'Velero Privado Vandross VI — 4,5 horas',
    provider: divePartnerInfo,
    sourceUrl: '',
    price: 890,
    priceUnit: 'salida privada',
    duration: '4 h 30 min',
    image: images.yacht,
    location: 'Gran Canaria',
    meetingPoint: 'Punto de embarque a confirmar',
    groupSize: 'Grupo privado · capacidad a confirmar',
    cancellationPolicy: diveCancellation,
    description: 'Navegación privada a bordo del Vandross VI con menú gourmet, vino de la casa y paradas para baño si las condiciones lo permiten.',
    included: ['Velero privado', 'Menú gourmet', 'Vino Vandross', 'Patrón y navegación'],
    ticketTypes: [{ id: 'private_departure', label: 'Salida privada', price: 890, max: 1, default: 1 }],
  }),
  manualActivity({
    id: 'gc-velero-privado-7h',
    title: 'Velero Privado Vandross VI — 7 horas',
    provider: divePartnerInfo,
    sourceUrl: '',
    price: 1090,
    priceUnit: 'salida privada',
    duration: '7 horas',
    image: images.yachtWide,
    location: 'Gran Canaria',
    meetingPoint: 'Punto de embarque a confirmar',
    groupSize: 'Grupo privado · capacidad a confirmar',
    cancellationPolicy: diveCancellation,
    description: 'Jornada privada de navegación en el Vandross VI con menú gourmet, vino de la casa y tiempo ampliado para disfrutar del mar.',
    included: ['Velero privado', 'Menú gourmet', 'Vino Vandross', 'Patrón y navegación'],
    ticketTypes: [{ id: 'private_departure', label: 'Salida privada', price: 1090, max: 1, default: 1 }],
  }),
];

const yachtCancellation = unpublishedCancellation('Socio de yates privados', '');

const yachtActivities = [
  manualActivity({
    id: 'gc-yate-crucero-snorkel',
    title: 'Nirvana Day Cruise & Snorkeling',
    provider: yachtPartnerInfo,
    sourceUrl: '',
    price: 720,
    priceUnit: 'yate privado',
    duration: '4 horas',
    image: images.yacht,
    location: 'Gran Canaria',
    meetingPoint: 'Puerto a confirmar con el proveedor',
    groupSize: 'Hasta 8 pers.',
    cancellationPolicy: yachtCancellation,
    description: 'Crucero privado con snorkel, paddle surf, donut tube, bebidas y snacks.',
    included: ['Yate privado con capitán, tripulación y combustible', 'Snorkel y 2 tablas SUP', 'Donut tube', 'Bebidas y snacks'],
    ticketTypes: [{ id: 'private_yacht', label: 'Yate hasta 8 personas', price: 720, max: 1, default: 1 }],
  }),
  manualActivity({
    id: 'gc-yate-gui-gui',
    title: 'Nirvana Güi Güi Hidden Gem Tour',
    provider: yachtPartnerInfo,
    sourceUrl: '',
    price: 1195,
    priceUnit: 'yate privado',
    duration: '6 horas',
    image: images.yachtWide,
    location: 'Costa oeste de Gran Canaria',
    meetingPoint: 'Puerto a confirmar con el proveedor',
    groupSize: 'Hasta 8 pers.',
    cancellationPolicy: yachtCancellation,
    description: 'Excursión privada a la playa de Güi Güi con actividades acuáticas, bebidas premium, snacks y paella.',
    included: ['Yate privado con tripulación y combustible', 'Snorkel, SUP, donut tube y sea scooter', 'Bebidas premium, snacks y paella'],
    ticketTypes: [{ id: 'private_yacht', label: 'Yate hasta 8 personas', price: 1195, max: 1, default: 1 }],
    featured: true,
  }),
  manualActivity({
    id: 'gc-yate-sunset-tour',
    title: 'Nirvana Sunset Tour',
    provider: yachtPartnerInfo,
    sourceUrl: '',
    price: 540,
    priceUnit: 'yate privado',
    duration: '3 horas',
    image: images.sunset,
    location: 'Gran Canaria',
    meetingPoint: 'Puerto a confirmar con el proveedor',
    groupSize: 'Hasta 8 pers.',
    cancellationPolicy: yachtCancellation,
    description: 'Puesta de sol privada en yate con bebidas, snacks, snorkel, paddle surf y parada de baño opcional.',
    included: ['Yate privado con tripulación y combustible', 'Snorkel, SUP y donut tube', 'Bebidas y snacks'],
    ticketTypes: [{ id: 'private_yacht', label: 'Yate hasta 8 personas', price: 540, max: 1, default: 1 }],
  }),
  manualActivity({
    id: 'gc-yate-privado-exclusivo',
    title: 'Nirvana Private Yacht Tour',
    provider: yachtPartnerInfo,
    sourceUrl: '',
    price: 540,
    priceUnit: 'yate privado',
    duration: '3 horas',
    image: images.yacht,
    location: 'Gran Canaria',
    meetingPoint: 'Puerto a confirmar con el proveedor',
    groupSize: 'Hasta 8 pers.',
    cancellationPolicy: yachtCancellation,
    description: 'Tour privado de relax y navegación con equipo de snorkel, paddle surf, donut tube, bebidas y snacks.',
    included: ['Yate privado con tripulación y combustible', 'Snorkel, SUP y donut tube', 'Bebidas y snacks'],
    ticketTypes: [{ id: 'private_yacht', label: 'Yate hasta 8 personas', price: 540, max: 1, default: 1 }],
  }),
  manualActivity({
    id: 'gc-yate-all-inclusive',
    title: 'Nirvana All Inclusive Water Adventure',
    provider: yachtPartnerInfo,
    sourceUrl: '',
    price: 780,
    priceUnit: 'yate privado',
    duration: '3 horas',
    image: images.jetSki,
    location: 'Gran Canaria',
    meetingPoint: 'Puerto a confirmar con el proveedor',
    groupSize: 'Hasta 6 pers. en tarifa base',
    cancellationPolicy: yachtCancellation,
    description: 'Salida privada con una aventura acuática a elegir entre jet ski, banana o Crazy UFO, además de snorkel y paddle surf.',
    included: ['Yate privado con tripulación y combustible', 'Una actividad acuática incluida', 'Snorkel, SUP, donut tube y sea scooter', 'Bebidas y snacks'],
    ticketTypes: [
      { id: 'base_group', label: 'Grupo hasta 6 personas', price: 780, max: 1, default: 1 },
      { id: 'extra_couple', label: 'Pareja extra (máx. 2 pers.)', price: 150, max: 1, default: 0 },
    ],
  }),
  manualActivity({
    id: 'gc-yate-delfines-chill',
    title: 'Nirvana Dolphin Spotting & Chill Cruise',
    provider: yachtPartnerInfo,
    sourceUrl: '',
    price: 900,
    priceUnit: 'yate privado',
    duration: '5 horas',
    image: images.dolphin,
    location: 'Gran Canaria',
    meetingPoint: 'Puerto a confirmar con el proveedor',
    groupSize: 'Hasta 8 pers.',
    cancellationPolicy: yachtCancellation,
    description: 'Crucero privado orientado a la observación ocasional de delfines, aves y vida marina. Los avistamientos no están garantizados.',
    included: ['Yate privado con tripulación y combustible', 'Navegación de observación de fauna'],
    notIncluded: ['Avistamiento garantizado de delfines'],
    ticketTypes: [{ id: 'private_yacht', label: 'Yate hasta 8 personas', price: 900, max: 1, default: 1 }],
  }),
];

const watersportsCancellation = unpublishedCancellation(
  'Socio de deportes acuáticos',
  ''
);

function watersportsActivity(options) {
  return manualActivity({
    provider: watersportsPartnerInfo,
    sourceUrl: '',
    location: 'Anfi del Mar, Gran Canaria',
    meetingPoint: 'Anfi del Mar Water Sports',
    pickup: 'Consultar recogida y punto exacto con OWA.',
    cancellationPolicy: watersportsCancellation,
    ...options,
  });
}

const watersportsActivities = [
  watersportsActivity({
    id: 'gc-anfi-jetski-alquiler',
    title: 'Moto Acuática en Anfi del Mar',
    price: 60,
    priceUnit: 'opción',
    duration: '20 o 30 minutos',
    image: images.jetSki,
    description: 'Conducción de moto acuática con opciones individuales y dobles de 20 o 30 minutos.',
    ticketTypes: [
      { id: 'single_20', label: '20 min · 1 persona', price: 60 },
      { id: 'double_20', label: '20 min · 2 personas', price: 70 },
      { id: 'single_30', label: '30 min · 1 persona', price: 90 },
      { id: 'double_30', label: '30 min · 2 personas', price: 90 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-jetski-safari',
    title: 'Jet Ski Safari',
    price: 135,
    priceUnit: 'moto',
    duration: '1 o 2 horas',
    image: images.jetSki,
    description: 'Safari guiado en moto acuática por la costa con opciones individual, doble y recorrido de dos horas.',
    ticketTypes: [
      { id: 'single_60', label: '1 hora', price: 135 },
      { id: 'double_60', label: 'Moto doble · 1 hora', price: 145 },
      { id: 'one_or_two_120', label: '1 o 2 personas · 2 horas', price: 235 },
    ],
    featured: true,
  }),
  watersportsActivity({
    id: 'gc-anfi-flyboard',
    title: 'Flyboard',
    price: 80,
    duration: '20 o 30 minutos',
    image: images.parasailing,
    description: 'Sesión de flyboard en Anfi del Mar con dos duraciones disponibles.',
    ticketTypes: [
      { id: 'flyboard_20', label: '20 minutos', price: 80 },
      { id: 'flyboard_30', label: '30 minutos', price: 100 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-parasailing',
    title: 'Paracaídas Acuático — Parasailing',
    price: 50,
    priceUnit: 'vuelo',
    duration: '10 minutos',
    image: images.parasailing,
    description: 'Vuelo en parasailing para una, dos o tres personas, con un peso máximo conjunto de 200 kg.',
    ticketTypes: [
      { id: 'solo', label: '1 persona', price: 50 },
      { id: 'double', label: '2 personas', price: 90 },
      { id: 'triple', label: '3 personas · máx. 200 kg', price: 130 },
      { id: 'spectator', label: 'Espectador a bordo', price: 15 },
    ],
    restrictions: ['Peso máximo conjunto para tres personas: 200 kg.', 'Actividad sujeta a viento y estado del mar.'],
  }),
  watersportsActivity({
    id: 'gc-anfi-speed-boat',
    title: 'Speed Boat',
    price: 40,
    duration: '20 min o 1 h 15 min',
    image: images.boatParty,
    description: 'Paseo rápido en embarcación con opción corta de 20 minutos o recorrido ampliado.',
    ticketTypes: [
      { id: 'speed_20', label: '20 minutos · 1 persona', price: 40 },
      { id: 'speed_75', label: '1 h 15 min · 1 persona', price: 59 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-banana-boat',
    title: 'Banana Boat',
    price: 15,
    duration: '10 minutos',
    image: images.jetSki,
    description: 'Recorrido de banana boat arrastrado por lancha para grupos.',
    groupSize: 'Mín. 3 pers.',
    ticketTypes: [{ id: 'person', label: 'Personas · mínimo 3', price: 15, max: 12, default: 3 }],
    restrictions: ['Reserva mínima de 3 participantes.'],
  }),
  watersportsActivity({
    id: 'gc-anfi-crazy-sofa',
    title: 'Crazy Sofa',
    price: 25,
    duration: '10 minutos',
    image: images.jetSki,
    description: 'Actividad de velocidad sobre sofá hinchable arrastrado por lancha.',
  }),
  watersportsActivity({
    id: 'gc-anfi-paddle-surf-alquiler',
    title: 'Alquiler de Paddle Surf',
    price: 15,
    duration: '1 o 2 horas',
    image: images.paddle,
    description: 'Alquiler de tabla de paddle surf en Anfi del Mar.',
    ticketTypes: [
      { id: 'sup_60', label: '1 hora', price: 15 },
      { id: 'sup_120', label: '2 horas', price: 20 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-water-bull',
    title: 'Water Bull',
    price: 25,
    duration: '10-12 minutos',
    image: images.jetSki,
    description: 'Actividad acuática de arrastre sobre hinchable Water Bull.',
  }),
  watersportsActivity({
    id: 'gc-anfi-wakeboard',
    title: 'Wakeboard',
    price: 60,
    duration: '15 o 30 minutos',
    image: images.paddle,
    description: 'Sesión de wakeboard con opción de 30 minutos acompañada por profesor.',
    ticketTypes: [
      { id: 'wake_15', label: '15 minutos', price: 60 },
      { id: 'wake_30_teacher', label: '30 minutos con profesor', price: 80 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-coche-patin',
    title: 'Coche Patín',
    price: 20,
    priceUnit: 'embarcación',
    duration: '1 hora',
    image: images.paddle,
    description: 'Alquiler de coche patín para navegar frente a Anfi del Mar.',
    groupSize: 'Hasta 4 pers.',
    ticketTypes: [{ id: 'pedal_boat', label: 'Coche patín hasta 4 personas', price: 20 }],
  }),
  watersportsActivity({
    id: 'gc-anfi-kayak-alquiler',
    title: 'Alquiler de Kayak',
    price: 10,
    priceUnit: 'canoa',
    duration: '1 hora',
    image: images.paddle,
    description: 'Alquiler de kayak individual o doble en Anfi del Mar.',
    bookingEnabled: true,
    ticketTypes: [
      { id: 'single_kayak', label: 'Canoa individual', price: 10 },
      { id: 'double_kayak', label: 'Canoa doble', price: 15 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-esqui-acuatico',
    title: 'Esquí Acuático',
    price: 60,
    duration: '15 o 30 minutos',
    image: images.paddle,
    description: 'Sesión de esquí acuático con opción de 30 minutos acompañada por profesor.',
    ticketTypes: [
      { id: 'ski_15', label: '15 minutos', price: 60 },
      { id: 'ski_30_teacher', label: '30 minutos con profesor', price: 80 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-sun-pack',
    title: 'Sun Pack',
    price: 89,
    priceUnit: 'persona desde',
    duration: 'Pack de actividades',
    image: images.parasailing,
    description: 'Pack con moto acuática, parasailing, banana o Crazy Sofa y servicio de hamaca y sombrilla.',
    included: ['Moto acuática', 'Parasailing', 'Banana o Crazy Sofa', 'Hamaca y sombrilla'],
    ticketTypes: [
      { id: 'pack_two', label: 'Pack para 2 personas', price: 178, max: 1, default: 1 },
      { id: 'pack_one', label: 'Pack para 1 persona', price: 109, max: 1, default: 0 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-fun-pack',
    title: 'Fun Pack',
    price: 73,
    priceUnit: 'persona desde',
    duration: 'Pack de actividades',
    image: images.jetSki,
    description: 'Pack combinado de moto acuática y parasailing.',
    included: ['Moto acuática', 'Parasailing'],
    ticketTypes: [
      { id: 'pack_two', label: 'Pack para 2 personas', price: 146, max: 1, default: 1 },
      { id: 'pack_one', label: 'Pack para 1 persona', price: 99, max: 1, default: 0 },
    ],
  }),
  watersportsActivity({
    id: 'gc-anfi-adventure-pack',
    title: 'Adventure Pack',
    price: 99,
    priceUnit: 'persona desde',
    duration: 'Pack de actividades',
    image: images.boatParty,
    description: 'Pack combinado de Speed Boat, parasailing y Crazy Sofa.',
    included: ['Speed Boat · 20 minutos', 'Parasailing · 8-10 minutos', 'Crazy Sofa · 10-12 minutos'],
    ticketTypes: [
      { id: 'pack_two', label: 'Pack para 2 personas', price: 198, max: 1, default: 1 },
      { id: 'pack_one', label: 'Pack para 1 persona', price: 105, max: 1, default: 0 },
    ],
  }),
  watersportsActivity({
    id: 'gc-mogan-catamaran-stingray',
    title: 'Catamarán Stingray',
    sourceUrl: '',
    priceSourceUrl: '',
    price: 79,
    duration: '4 horas',
    image: images.catamaran,
    location: 'Puerto de Mogán, Gran Canaria',
    meetingPoint: 'Puerto de Mogán',
    pickup: 'Recogida incluida desde hoteles del sur, según las zonas publicadas.',
    groupSize: 'Grupo reducido',
    description: 'Navegación en catamarán por la costa de Gran Canaria con almuerzo, bebidas, snorkel y paddle surf.',
    included: ['Almuerzo con productos locales', 'Bebidas ilimitadas', 'Snorkel y paddle surf', 'Recogida desde hoteles del sur'],
    featured: true,
  }),
  watersportsActivity({
    id: 'gc-catamaran-bluefin-compartido',
    title: 'Catamarán Bluefin — Salida Compartida',
    sourceUrl: '',
    price: 99,
    duration: 'Duración a confirmar',
    image: images.catamaran,
    location: 'Puerto de Mogán, Gran Canaria',
    meetingPoint: 'Puerto de Mogán',
    groupSize: 'Hasta 12 pers.',
    description: 'Salida compartida en el catamarán Lagoon 42 Bluefin con patrón profesional.',
    included: ['Patrón profesional', 'Navegación en grupo reducido'],
  }),
  watersportsActivity({
    id: 'gc-catamaran-bluefin-privado',
    title: 'Catamarán Bluefin — Salida Privada',
    sourceUrl: '',
    price: 900,
    priceUnit: 'salida privada desde',
    duration: '2, 3, 4, 6 u 8 horas',
    image: images.catamaran,
    location: 'Puerto de Mogán, Gran Canaria',
    meetingPoint: 'Puerto de Mogán',
    groupSize: 'Hasta 12 pers.',
    description: 'Alquiler privado del catamarán Lagoon 42 Bluefin con patrón profesional y duración personalizable.',
    included: ['Catamarán privado', 'Patrón profesional'],
    ticketTypes: [{ id: 'private_departure', label: 'Salida privada desde', price: 900, max: 1, default: 1 }],
  }),
];

const otherActivities = [
  manualActivity({
    id: 'gc-catamaran-todo-incluido',
    title: 'Catamarán Todo Incluido en Gran Canaria',
    provider: { id: 'gc-catamaran-partner', name: 'Socio de catamarán' },
    sourceUrl: '',
    priceSourceUrl: '',
    price: 69,
    duration: '4 horas',
    image: images.catamaran,
    location: 'Puerto Rico, Gran Canaria',
    meetingPoint: 'Puerto Rico, punto exacto a confirmar',
    groupSize: 'Excursión compartida',
    cancellationPolicy: unpublishedCancellation('Socio de catamarán', ''),
    description: 'Excursión en catamarán por Gran Canaria con comida, bebidas y material de snorkel.',
    included: ['Comida y bebidas', 'Material de snorkel', 'Tripulación profesional'],
    ticketTypes: [
      { id: 'adult', label: 'Adultos', price: 69, max: 30, default: 2 },
      { id: 'child', label: 'Niños', price: 45, max: 20, default: 0 },
    ],
  }),
  manualActivity({
    id: 'puerto-rico-boat-party',
    title: 'Boat Party desde Puerto Rico',
    provider: { id: 'gc-verified-partner', name: 'Socio local verificado' },
    sourceUrl: '',
    price: 60,
    duration: '4 horas',
    image: images.boatParty,
    location: 'Puerto Rico, Gran Canaria',
    meetingPoint: 'Puerto Base, Puerto Rico',
    pickup: 'Punto de encuentro en el puerto; confirmar instrucciones en la reserva.',
    groupSize: 'Fiesta compartida · solo adultos',
    cancellationPolicy: partnerVerifiedCancellation,
    description: 'Fiesta en barco por la costa suroeste de Gran Canaria con DJ, música, bebidas y ambiente para adultos.',
    included: ['Navegación de 4 horas', 'DJ y música', 'Bebidas según la opción del operador'],
    notIncluded: ['Extras premium no indicados en la tarifa base'],
    restrictions: ['Actividad para mayores de 18 años.', 'Es necesario presentar identificación válida.'],
    timeSlots: ['15:30'],
    featured: true,
  }),
];

export const additionalActivities = [
  ...yachtTourActivities,
  ...buggyTourActivities,
  ...wildlifeActivities,
  ...diveActivities,
  ...yachtActivities,
  ...watersportsActivities,
  ...otherActivities,
];
